import type { TooltipProps } from 'recharts'

/** Palette for multi-series charts, in the order they should be used. */
export const SERIES_COLORS = [
  'var(--brand)',
  'var(--blue)',
  'var(--teal)',
  'var(--amber)',
  'var(--purple)',
  'var(--orange)',
  'var(--green)',
  'var(--grey)',
]

export const AXIS = {
  stroke: 'var(--border-strong)',
  fontSize: 11,
  tick: { fill: 'var(--text-faint)', fontSize: 11 },
}

export const GRID = { stroke: 'var(--border)', strokeDasharray: '3 3' }

/**
 * Recharts' default tooltip ignores our type and spacing. This one takes a
 * formatter per series so money and counts can sit in the same tooltip.
 */
export function ChartTip({
  active,
  payload,
  label,
  format,
}: TooltipProps<number, string> & { format?: (name: string, value: number) => string }) {
  if (!active || !payload?.length) return null
  return (
    <div className="chart-tip">
      <div className="tip-label">{label}</div>
      {payload.map((entry) => (
        <div className="tip-row" key={entry.name ?? entry.dataKey}>
          {entry.name}:{' '}
          <strong>
            {format
              ? format(String(entry.name ?? ''), Number(entry.value ?? 0))
              : Number(entry.value ?? 0).toLocaleString()}
          </strong>
        </div>
      ))}
    </div>
  )
}
